/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';

import apprenticesPairArmsFolded from '../../images/characters/apprenticesPairArmsFolded.png';
import apprenticesPairHandsHips from '../../images/characters/apprenticesPairHandsHips.png';
import apprenticePointingDiagonal from '../../images/characters/apprenticePointingDiagonal.png';
import apprenticePointingUp from '../../images/characters/apprenticePointingUp.png';
import apprenticesBackToBack from '../../images/characters/apprenticesBackToBack.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1a from './level1a_emergencyKit.md';
import markdownFileLevel1b from './level1b_makeAPlan.md';

const levels = {
  '1a': { md: new MarkdownScript(markdownFileLevel1a) },
  '1b': { md: new MarkdownScript(markdownFileLevel1b) }
};

export function preloadClassActivity () {
  preloader([
    apprenticesPairArmsFolded,
    apprenticesPairHandsHips,
    apprenticePointingDiagonal,
    apprenticePointingUp,
    apprenticesBackToBack
  ]);
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'sizzle',
      characterSide: 'right',
      characterImage: apprenticePointingUp,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
    })
  );
}

function instructions (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'instructions',
      characterSide: 'left',
      characterImage: apprenticesPairHandsHips,
      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
    })
  );
}


function answers (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'answers',
      characterSide: 'right',
      characterImage: apprenticesPairArmsFolded,
      notes: md.getSubSectionAsHtml('Answers', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Answers', 'Content', false, regionData)
    })
  );
}

function level1a (regionData) { // Emergency Kit
  const level = '1a';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Time's Up! */}
      {balloonSlide({
        id: 'time-up',
        characterSide: 'right',
        characterImage: apprenticePointingDiagonal,
        notes: md.getSubSectionAsHtml('Time Up', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Time Up', 'Content', false, regionData)
      })}

      {/* Collate lists */}
      {balloonSlide({
        id: 'collate-lists',
        characterSide: 'left',
        characterImage: apprenticesBackToBack,
        notes: md.getSubSectionAsHtml('Collate Lists', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Collate Lists', 'Content', false, regionData)
      })}

      {/* Answers */}
      {answers(level, regionData)}

    </Section>
  );
}

function level1b (regionData) { // Popcorn Joys
  const level = '1b';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Answers */}
      {answers(level, regionData)}

    </Section>
  );
}

function classActivitySection ({ level, subActivity, regionData }) {
  switch (`${level}${subActivity ? subActivity : ''}`) {
  case '1a':
    return level1a(regionData);
  case '1b':
    return level1b(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default classActivitySection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/40_classActivity/classActivitySection.jsx